import { useEffect, useRef, useState } from "react";
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import useDateEvents from "../../hooks/timeline/useDateEvents";

import { dimensions, mockEvents,
  TimelineTableHead,
  TimelineTableDateEventBar,
  TimelineSpacer,
  TimelineFullDateEventsContainer,
  TimelineLegalHolidays,
  TimelineJewishHolidays,
  TimelineIconContainer,
  TimelineTableBodyContainer,
  TimelineTrackHeader,
  TimelineTrackHeaderScroll,
  TimelineTableBody,
  TableTimelineDisplay,
  TimelineEventBoard,
  TimelineHoursColumn,
  TimelineRibbon,
  TimelineSeeker,
  TimelineTrack,
  TimelineTrackTitle,


  PrintTimelineEvents,
  // PrintTimelineDisplay,
  PrintTimelineDay,
  // PrintTimelineHours,
  PrintTimelineHebEvents
 } from "./Common";

import PrintTimelineDisplay from "./Components/TimelineTile";
import PrintTimelineHours from "./Components/TimelineHours";
import TimelineContainer from "./Components/TimelineContainer";

import { getYPos, roundMinutesToNearestPoint, roundToPointOfHourTime, getWeekDay, findEventInDate } from './helpers';

import WatchLaterIcon from '@mui/icons-material/WatchLater';

import { useCalendarContext } from "../../contexts/Calendar";

const Container = styled.div`

`;


const DayComponent = ({hours = 24, divide = 2, curDate = {}, createEvent, display = "vertical", stylistId}) => {

  const dateEvents = useDateEvents({start_date: curDate});

  const {day, year, month, fullDate, scheduledEvents = [], dayOfWeek} = dateEvents;

  const { setting } = useCalendarContext() || {};

  let { view_density, display_hours } = setting?.data || {};

  let rowHeight = +view_density || dimensions.timeline.hour.height;
  let beginShow = +display_hours?.start ? +display_hours?.start : 0;

  let curHour = new Date().getHours();
  let startHour = getYPos(curHour, rowHeight)
  let roundedTime = roundMinutesToNearestPoint(new Date());
  let seekerPos = getYPos(curHour + (roundedTime / 100), rowHeight);


  const tableBodyRef = useRef(null);
  const trackHeaderRef = useRef(null);
  const timelineDisplayRef = useRef(null);

  let scrollEvent = null;

  const scrollHorizontal = (e) => {
    let scroll = e.deltaY;
    timelineDisplayRef.current.scrollBy({
      top: 0,
      left: scroll,
      // behavior: 'smooth'
    })
    trackHeaderRef.current.scrollBy({
      top: 0,
      left: scroll,
      // behavior: 'smooth'
    })
  }

  // useEffect(() => {
  //   tableBodyRef.current.scrollTo(0, 0)
  //   tableBodyRef.current.scrollBy({
  //     top: startHour,
  //     left: 0,
  //     behavior: 'smooth'
  //   })
  //   console.log(document.getElementById('timeline1').getBoundingClientRect().width)
  // }, [])

  return (
    <Container>
      <TimelineTableHead>
        <TimelineRibbon>
          <TimelineIconContainer>
            <WatchLaterIcon fontSize="large" />
          </TimelineIconContainer>
          <PrintTimelineDay day={dayOfWeek} date={fullDate} dayOfMonth={day} />
        </TimelineRibbon>
      </TimelineTableHead>
      <TimelineTableDateEventBar>
        <TimelineFullDateEventsContainer>
          <TimelineLegalHolidays>
          </TimelineLegalHolidays>
          <TimelineJewishHolidays $reverse>
            <PrintTimelineHebEvents date={fullDate} />
          </TimelineJewishHolidays>
        </TimelineFullDateEventsContainer>
      </TimelineTableDateEventBar>

      <TimelineTableBodyContainer ref={tableBodyRef}>
          
        <TimelineTableBody>
        <TimelineHoursColumn>
          <PrintTimelineHours />
        </TimelineHoursColumn>
        <TableTimelineDisplay $columns={1} ref={timelineDisplayRef}>
          <TimelineSeeker pos={seekerPos} /> {/* Seeker to show current time */}
            <TimelineTrack>
              <TimelineEventBoard id={`timeline1`}>
                <PrintTimelineEvents events={scheduledEvents} track={`timeline1`} />
              {/* <TimelineEventBoard onClick={(e) => createNewEvent(e)}>
                <PrintTimelineEvents events={scheduledEvents} track={stylistId} /> */}
                
              </TimelineEventBoard>

              <PrintTimelineDisplay 
                hours={hours} 
                track={1}
                id={`timeline1`}
                date={fullDate}
              />
            </TimelineTrack>
         
        </TableTimelineDisplay>

        </TimelineTableBody>

      </TimelineTableBodyContainer>
    </Container>
  )
}

export default DayComponent;